function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModuleSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface94561989"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,98.431373%,98.431373%)",
      fillOpacity: 1
    },
    d: "M 10.050781 24 C 10.546875 16.527344 16.527344 10.546875 24 10.050781 L 24 2.023438 C 12.113281 2.535156 2.535156 12.113281 2.023438 24 Z M 26 10.050781 C 33.472656 10.546875 39.453125 16.527344 39.949219 24 L 47.972656 24 C 47.464844 12.113281 37.886719 2.535156 26 2.023438 Z M 39.949219 26 C 39.453125 33.472656 33.472656 39.453125 26 39.949219 L 26 47.972656 C 37.886719 47.464844 47.464844 37.886719 47.976562 26 Z M 24 39.949219 C 16.527344 39.453125 10.546875 33.472656 10.050781 26 L 2.023438 26 C 2.535156 37.886719 12.113281 47.464844 24 47.976562 Z M 24 39.949219 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleSwitch);
export default __webpack_public_path__ + "static/media/module-switch.561fd88d3cf95464dd1b8e09e329ac76.svg";
export { ForwardRef as ReactComponent };